<div *ngIf="isOpen"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4 animation-fade-in">
  <div
    class="bg-white dark:bg-slate-900 rounded-3xl shadow-2xl w-full max-w-lg overflow-visible flex flex-col border border-transparent dark:border-slate-800 relative"
    (click)="$event.stopPropagation()">

    <div
      class="px-6 py-5 border-b border-slate-100 dark:border-slate-800 flex justify-between items-center bg-white dark:bg-slate-900 rounded-t-3xl sticky top-0 z-10">
      <div>
        <h3 class="text-lg font-bold text-slate-800 dark:text-white tracking-tight flex items-center gap-2">
          <span class="material-icons text-amber-500">add_circle</span>
          ทำรายการเข้า EV
        </h3>
        <p class="text-xs font-medium text-slate-400 mt-1">{{ gateName || '—' }}</p>
      </div>
      <button type="button" (click)="closeModal()" [disabled]="isSaving"
        class="w-8 h-8 rounded-full flex items-center justify-center hover:bg-slate-50 dark:hover:bg-slate-800 text-slate-400 hover:text-slate-700 transition-all border-none cursor-pointer bg-transparent disabled:opacity-50">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="p-6 space-y-5 overflow-visible">
      <!-- LINE user — dropdown ลงด้านล่าง -->
      <div class="relative z-30">
        <label class="block text-xs font-bold text-slate-500 dark:text-slate-400 mb-2">
          ลูกค้า LINE <span class="text-rose-500">*</span>
        </label>
        <div class="relative">
          <span
            class="absolute left-4 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px] pointer-events-none">search</span>
          <input type="text" [(ngModel)]="searchLineText" (ngModelChange)="onLineSearchChange()"
            (focus)="onInputFocus('line')" (blur)="closeDropdowns()" placeholder="ค้นหาชื่อ หรือเบอร์โทร..."
            [disabled]="isSaving"
            class="w-full h-[48px] pl-11 pr-10 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-xl text-sm font-medium text-slate-700 dark:text-slate-200 focus:bg-white dark:focus:bg-slate-800 focus:ring-2 focus:ring-amber-200 outline-none transition-all disabled:opacity-60">
          <span class="material-icons text-slate-400 text-sm absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none"
            [class.rotate-180]="openDropdown==='line'">expand_more</span>
        </div>
        <div *ngIf="openDropdown === 'line'" (mousedown)="$event.preventDefault()"
          class="absolute top-full left-0 right-0 mt-2 z-[80] bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-2 max-h-60 overflow-y-auto custom-scrollbar">
          <div *ngIf="isSearchingLine" class="px-4 py-3 text-sm text-slate-400 text-center font-bold">กำลังค้นหา...</div>
          <div *ngIf="!isSearchingLine && lineOptions.length === 0"
            class="px-4 py-3 text-sm text-slate-400 text-center font-bold">ไม่พบผู้ใช้ LINE</div>
          <button *ngFor="let user of lineOptions" type="button" (click)="selectLineUser(user)"
            class="w-full text-left px-4 py-2.5 text-sm font-bold hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-600 cursor-pointer transition-all text-slate-700 dark:text-slate-300 border-none bg-transparent">
            <div>{{ user.fullName || user.name }}</div>
            <div class="text-[11px] font-medium text-slate-400">{{ user.phone || 'ไม่มีเบอร์' }}</div>
          </button>
        </div>
      </div>

      <!-- Vehicle — dropdown ลงด้านล่าง -->
      <div class="relative z-20">
        <label class="block text-xs font-bold text-slate-500 dark:text-slate-400 mb-2">
          ทะเบียนรถ <span class="text-rose-500">*</span>
        </label>
        <div class="relative">
          <span
            class="absolute left-4 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px] pointer-events-none">directions_car</span>
          <input type="text" [(ngModel)]="searchVehicleText"
            (focus)="onInputFocus('vehicle')" (blur)="closeDropdowns()"
            placeholder="{{ selectedLine ? 'เลือกทะเบียน...' : 'เลือกลูกค้า LINE ก่อน' }}"
            [disabled]="isSaving || !selectedLine || isLoadingVehicles"
            class="w-full h-[48px] pl-11 pr-10 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-xl text-sm font-medium text-slate-700 dark:text-slate-200 focus:bg-white dark:focus:bg-slate-800 focus:ring-2 focus:ring-amber-200 outline-none transition-all disabled:opacity-60">
          <span class="material-icons text-slate-400 text-sm absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none"
            [class.rotate-180]="openDropdown==='vehicle'">expand_more</span>
        </div>
        <div *ngIf="openDropdown === 'vehicle' && selectedLine" (mousedown)="$event.preventDefault()"
          class="absolute top-full left-0 right-0 mt-2 z-[80] bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-2 max-h-60 overflow-y-auto custom-scrollbar">
          <div *ngIf="isLoadingVehicles" class="px-4 py-3 text-sm text-slate-400 text-center font-bold">กำลังโหลด...</div>
          <div *ngIf="!isLoadingVehicles && filteredVehicles.length === 0"
            class="px-4 py-3 text-sm text-slate-400 text-center font-bold">ไม่พบทะเบียน</div>
          <button *ngFor="let v of filteredVehicles" type="button" (click)="selectVehicle(v)"
            class="w-full text-left px-4 py-2.5 text-sm font-bold hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-600 cursor-pointer transition-all text-slate-700 dark:text-slate-300 border-none bg-transparent">
            {{ v.label }}
          </button>
        </div>
      </div>
    </div>

    <div
      class="px-6 py-4 border-t border-slate-100 dark:border-slate-800 bg-slate-50 dark:bg-slate-900/80 flex justify-end gap-3 rounded-b-3xl relative z-10">
      <button type="button" (click)="closeModal()" [disabled]="isSaving"
        class="px-5 py-2.5 rounded-xl text-slate-600 dark:text-slate-300 font-bold hover:bg-slate-200 dark:hover:bg-slate-700 transition-all disabled:opacity-50 border-none cursor-pointer bg-transparent">
        ยกเลิก
      </button>
      <button type="button" (click)="askSubmit()" [disabled]="isSaving"
        class="cursor-pointer px-5 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold shadow-md active:scale-95 transition-all flex items-center gap-2 disabled:opacity-50 border-none">
        <span *ngIf="isSaving"
          class="w-4 h-4 border-2 border-slate-900 border-t-transparent rounded-full animate-spin"></span>
        <span>{{ isSaving ? 'กำลังบันทึก...' : 'ทำรายการเข้า' }}</span>
      </button>
    </div>
  </div>
</div>

<app-pss-confirm-modal *ngIf="showConfirm" title="ยืนยันทำรายการเข้า"
  [message]="'ทำรายการเข้าช่อง ' + (gateName || '') + ' สำหรับทะเบียน ' + (selectedVehicle?.plateNumber || '') + '?'"
  confirmLabel="ยืนยัน" cancelLabel="ยกเลิก" variant="warning" icon="ev_station"
  [showIrreversibleNote]="false"
  (confirm)="confirmSubmit()" (cancel)="closeConfirm()">
</app-pss-confirm-modal>

<app-pss-loading *ngIf="isSaving"></app-pss-loading>
